// extracted by mini-css-extract-plugin
export default {"container":"concepts-page_container__Qto6Y","content":"concepts-page_content__ALKaL","rootSkill":"concepts-page_rootSkill__y6f86","subSkill":"concepts-page_subSkill__Y5vdl"};